import { Checkbox } from "@mui/material";
import { ReactElement, useState } from "react";
import { useTranslation } from "react-i18next";
import { components, MenuProps } from "react-select";

import { SelectAllOption } from "./select-all-option";
import { SelectNoneOption } from "./select-none-option";
import { StickyOptionsFocusContext } from "./sticky-option-focus.context";

interface IFilterMultiselectMenuProps extends MenuProps {
  selectAll: () => void;
  isSelectedAll: boolean;
  isSelectNoneValueActive?: boolean;
  isSelectNoneOptionEnabled?: boolean;
  isSelectAllOptionEnabled?: boolean;
  toggleFilterSelectNoneValue?: () => void;
}

export const FilterMultiselectMenu = ({
  children,
  selectAll,
  isSelectedAll,
  isSelectNoneValueActive,
  toggleFilterSelectNoneValue,
  isSelectNoneOptionEnabled,
  isSelectAllOptionEnabled = true,
  ...props
}: IFilterMultiselectMenuProps): ReactElement => {
  const [isSelectAllFocused, setIsSelectAllFocused] = useState(false);
  const [isSelectNoneFocused, setIsSelectNoneFocused] = useState(false);
  const { t } = useTranslation();

  return (
    <components.Menu {...props}>
      {isSelectAllOptionEnabled && (
        <SelectAllOption
          isSelected={isSelectedAll}
          isFocused={isSelectAllFocused}
          onFocus={setIsSelectAllFocused}
        >
          <Checkbox
            sx={{ marginInlineEnd: 2 }}
            onChange={selectAll}
            checked={isSelectedAll}
          />
          {t("general.SELECT_ALL")}
        </SelectAllOption>
      )}
      {isSelectNoneOptionEnabled && (
        <SelectNoneOption
          isSelected={!!isSelectNoneValueActive}
          isFocused={isSelectNoneFocused}
          onFocus={setIsSelectNoneFocused}
        >
          <Checkbox
            sx={{ marginInlineEnd: 2 }}
            onChange={toggleFilterSelectNoneValue}
            checked={isSelectNoneValueActive}
          />
          {t("general.SELECT_NONE")}
        </SelectNoneOption>
      )}
      <StickyOptionsFocusContext.Provider
        value={isSelectAllFocused || isSelectNoneFocused}
      >
        {children}
      </StickyOptionsFocusContext.Provider>
    </components.Menu>
  );
};
